
import { defineComponent,onMounted, inject, ref } from "vue";

import fixedFooter from "@/components/common/Footer.vue";

import axios from "@/api/axios";

import Toast from "@/components/UI/Toast";
import Preview from "@/components/UI/Preview";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import Modal from "@/components/UI/Modal";
import { wechatLoginMine } from "@/api/wechatLogin";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "Mine",
  components: {
    fixedFooter,
    Preview,
  },
  setup() {
    const router = useRouter();
    //  展示用户信息
    const userInfo = inject("userInfo") as any;
    // onMounted(()=>{
    //   // alert("页面渲染之前执行，执行完，页面就出来了");
    //   // console.log('userInfo',userInfo)
    //   //用户信息不全，但是token还存在的情况下，清除用户信息和token，跳转登录页面重新登录
    //   if (!userInfo.id) {
    //     localStorage.removeItem("token");
    //     Toast({
    //       type: "error",
    //       title: "请先登录再执行其他操作",
    //     });
    //     router.push({
    //       path: "/login",
    //       query: {
    //         redirect: '/mine',
    //       },
    //     });
    //     return false;
    //   }
    // })
    const route = useRoute();
    const UPDATE_USERINFO = inject("UPDATE_USERINFO") as (data: object) => void;
    function handleUserInfo(data: object) {
      UPDATE_USERINFO(data);
    }
    function updateToken(token: string) {
      localStorage.setItem("token", token);
    }
    wechatLoginMine(route.query.code as string, route.query.state as string).then((res: any) => {
      if (typeof res === "object" && res.data.success) {
        updateToken(res.data.token);
        handleUserInfo(res.data.obj);
      }
    })
    onBeforeRouteLeave((to, from) => {
      if (new Date().getHours() < 8 || new Date().getHours() >= 23) {
        if (
          to.name == "Order" ||
          to.name == "Invoice" ||
          to.name == "Bill" ||
          to.name == "Intergral"
        ) {
          Modal({
            title: "温馨提醒",
            content: "23:00-8:00期间此功能正在维护中...",
          });
          return false;
        }
      }
    });
    //  预览大图
    const previewing = ref(false);
    function closePreview() {
      previewing.value = false;
    }
    function showPreview() {
      previewing.value = true;
    }



    function jumpRed() {
      router.push({
        name: "WechatRed",
      });
    }
    return {
      userInfo,
      previewing,
      showPreview,
      closePreview,
      jumpRed
    };
  },
});
